import { I_competition_entry } from './i_competition_entry.interface';

export class Competition_entry implements I_competition_entry {
	id: string;
	user_id: string;
	horse_show_id: string;
	entry_id: string;
	entry_number: number;
	competition_id: string;
	competition_number: number;
	competition_name: string;
	horse_name: string;
	section_id: string;
	section_number: number;
	section_name: string;
	organizer_id: string;
	rider_person_id: string;
	status: string;
	start_position: number;
	split: string;
	placing: number;
	tie: string;
	late: boolean;
	competed: boolean;
	usef_point_section: string;
	obstacle_height: string;
	person_name_rider: string;
	rider_usef_id: string;
	rider_ec_id: string;
	rider_fei_id: string;
	restrict_scratch: string;
	is_section_entry: boolean = false;
	pending: boolean;

	mark_for_removal: boolean;
	
	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}